import { render, staticRenderFns } from "./XMLImport.vue?vue&type=template&id=267aa1b0&scoped=true&"
import script from "./XMLImport.vue?vue&type=script&lang=js&"
export * from "./XMLImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267aa1b0",
  null
  
)

export default component.exports